import React from "react";

function Other() {
  return (
    <div>
      <div class="Thumbnail"></div>
      <div class="ThumbnailMargin"></div>

      <div class="contentAfter col-md-10 mt-5 mb-5 p-2 ms-auto me-auto">
        <div class="text-center mb-5 w-full mx-auto">
          <span class="text-hollow text-transparent">
            Other Security Services
          </span>
        </div>
        <p>Other security services offered by Cyphinix are:</p>

        <div class="row">
          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Phishing Simulation</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Phishing is a widely spreading methodology used by hackers
                    to trick their target victims into fraud by creating
                    authentic-looking websites, emails, or emails of an
                    authentic company for stealing personal and financial
                    information. It is crucial to identify their traps and not
                    fall into them.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Spam and DDOS Management</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Live Attack Stop and Preventative Measures- Distributed
                    Denial of Services is an attacking technique used by hackers
                    to slow down a server or make it temporarily unavailable by
                    flooding it with traffic with a motive to damage the
                    reputation and blackmail businesses. Hence, stopping these
                    live attacks and spam requests and taking preventative
                    measures are necessary to stay safe in this digital world.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Email Security</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Where sending and receiving Emails have become the most
                    preferred way of communicating, sending emails for hacking
                    the systems, networks, devices, and applications have become
                    the most preferred way of hacking by hackers. Therefore,
                    securing emails and the information inside emails from
                    unauthorized usage, email security is a must.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Other;
